namespace Matrix.Workflow {
    export interface WorkflowMapBatchAssignmentResponse extends Serenity.ServiceResponse {
        Existing?: number;
        Inserted?: number;
    }
}
